import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Cookie, UserX } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <Link
          to="/"
          className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Retour au simulateur
        </Link>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Politique de confidentialité</h1>

          <div className="prose max-w-none text-gray-600 space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <Shield className="w-6 h-6 text-blue-600 mr-2" />
                  <h2 className="text-lg font-semibold text-blue-900">Protection des données</h2>
                </div>
                <p className="text-blue-800">
                  Toutes vos données sont traitées localement dans votre navigateur. Aucune information n'est stockée sur nos serveurs.
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <Lock className="w-6 h-6 text-blue-600 mr-2" />
                  <h2 className="text-lg font-semibold text-blue-900">Confidentialité</h2>
                </div>
                <p className="text-blue-800">
                  Vos informations restent privées et sont effacées dès que vous quittez la page.
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <Cookie className="w-6 h-6 text-blue-600 mr-2" />
                  <h2 className="text-lg font-semibold text-blue-900">Cookies</h2>
                </div>
                <p className="text-blue-800">
                  Notre simulateur ne nécessite aucun cookie pour fonctionner.
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <UserX className="w-6 h-6 text-blue-600 mr-2" />
                  <h2 className="text-lg font-semibold text-blue-900">Pas de compte requis</h2>
                </div>
                <p className="text-blue-800">
                  Aucune inscription ou identification n'est nécessaire pour utiliser le simulateur.
                </p>
              </div>
            </div>

            <h2 className="text-xl font-semibold text-gray-900 mt-8">Traitement des données</h2>
            <p>
              Notre simulateur fonctionne entièrement côté client, ce qui signifie que toutes les données que vous saisissez sont traitées uniquement dans votre navigateur. Nous n'avons pas accès à ces informations et ne les collectons pas.
            </p>

            <h2 className="text-xl font-semibold text-gray-900">Engagement de confidentialité</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Aucune donnée n'est collectée ni stockée sur nos serveurs</li>
              <li>Les calculs sont effectués localement dans votre navigateur</li>
              <li>Aucun cookie n'est utilisé pour le fonctionnement du simulateur</li>
              <li>Aucune information personnelle n'est partagée avec des tiers</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;